export default "__VITE_ASSET__BrQL9Qbp__"